var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "#0847F7",
    rx: 22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8FAFF",
    d: "m22.005 8-2.569 1.477-7 4.046L9.867 15v14l2.57 1.477 7.063 4.046L22.07 36l2.568-1.477 6.936-4.046L34.144 29V15l-2.57-1.477-7-4.046zm-7 18.046v-8.092l7-4.046 7 4.046v8.092l-7 4.046z"
  })));
};
export default SvgLink;